<template>
    <Calendar
    :eventCategories="eventCategories"
    :events="events"
    :monthNames="monthNames"
    :weekdaysNames="weekdaysNames"
    :firstDayOfWeek="2"
    v-on:nextMonthEvent="nextMonthEvent"
    v-on:prevMonthEvent="prevMonthEvent"
    v-on:selectedDateEvent="selectedDateEvent"
    ref="calendar"
    />
</template>

<script>
    import Calendar from '../../calendar/Calendar'
    import axios from 'axios'
    import env from '@/enviroment';
    import lStorage from '@/store/localStorage';
    import store from '@/store';
    import {rest} from '@/utils/utils';
    import i18n from '@/i18n';
    
    export default {
        name: "CalendarSchedule",
        components: {
            Calendar,
        },
        data: function(){
            return {
                monthNames: [
                    i18n.t('strings.MONTH_1'),
                    i18n.t('strings.MONTH_2'),
                    i18n.t('strings.MONTH_3'),
                    i18n.t('strings.MONTH_4'),
                    i18n.t('strings.MONTH_5'),
                    i18n.t('strings.MONTH_6'),
                    i18n.t('strings.MONTH_7'),
                    i18n.t('strings.MONTH_8'),
                    i18n.t('strings.MONTH_9'),
                    i18n.t('strings.MONTH_10'),
                    i18n.t('strings.MONTH_11'),
                    i18n.t('strings.MONTH_12')
                ],
                weekdaysNames:[
                    i18n.tc('strings.WK_SUN'),
                    i18n.tc('strings.WK_MON'),
                    i18n.tc('strings.WK_TUE'),
                    i18n.tc('strings.WK_WED'),
                    i18n.tc('strings.WK_THU'),
                    i18n.tc('strings.WK_FRI'),
                    i18n.tc('strings.WK_SAT'),
                ],
                eventCategories: [
                    {
                        id: 'free',
                        title: 'free',
                        textColor: '#0B1022',
                        backgroundColor: 'inherit'
                    },
                ],
                events: []
            }
        },
        created() {
            let today = new Date();
            this.updateSchedule({
                'month': today.getMonth() + 1,
                'year': today.getFullYear()
            });
        },
        methods: {
            nextMonthEvent(date){
                this.updateSchedule(date);
            },
            prevMonthEvent(date){
                this.updateSchedule(date);
            },
            selectedDateEvent(date){
                var now = new Date(),
                requested = new Date(date.year+"-"+date.month+"-"+date.day);
                var date1 = Date.UTC(now.getFullYear(),now.getMonth(),now.getDate());
                var date2 = Date.UTC(requested.getFullYear(),requested.getMonth(),requested.getDate());
                var diff = Math.floor((requested-now) / (1000*60*60*24));

                if(diff>=1){
                    this.$emit('selectedDateEvent',`${date.year}-${date.month<10?'0'+date.month:date.month}-${date.day<10?'0'+date.day:date.day}`,true);
                }else{
                    this.$emit('selectedDateEvent',`${date.year}-${date.month<10?'0'+date.month:date.month}-${date.day<10?'0'+date.day:date.day}`,false);
                }
            },
            updateSchedule(date){
                store.commit('loading/is',true);
                
                rest.call("lessons_workload",{
                    "type":"trial",
                    "month":date.month || new Date().getMonth(),
                    "year":date.year || new Date().getFullYear(),
                }).then((response)=>{
                    store.commit('loading/is',false);
                    if(response && response.list){
                        let scheduleArr = [];
                        for(var key in response.list){
                            if(response.list.hasOwnProperty(key)){
                                scheduleArr.push({
                                    start: key,
                                    end: key,
                                    status: response.list[key],
                                    repeat: 'never',
                                    categoryId: response.list[key]
                                });
                            }
                        }
                        this.events = scheduleArr;
                    }
                }).catch((error)=>{
                    store.commit('loading/is',false);
                });
            }
        }
    }
</script>

<style scoped>

</style>
